import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { SiteFooterSitemap } from "./site-footer-sitemap";
import {
  SiteFooterBrand,
  type SiteFooterBrandProps,
} from "./site-footer-brand";
import type { SiteFooterLinkItem } from "./site-footer-types";
import type { ReactNode } from "react";

export type SiteFooterViewProps = SiteFooterBrandProps & {
  readonly browseItems: readonly SiteFooterLinkItem[];
  readonly productItems: readonly SiteFooterLinkItem[];
  readonly aboutItems: readonly SiteFooterLinkItem[];
  readonly legalItems: readonly SiteFooterLinkItem[];
  readonly renderSignedInOnly: (children: ReactNode) => ReactNode;
};

export function SiteFooterView({
  homeHref,
  browseItems,
  productItems,
  aboutItems,
  legalItems,
  socialItems,
  brand,
  renderLink,
  renderSignedInOnly,
}: SiteFooterViewProps) {
  return (
    <footer {...stylex.props(localStyles.footer)}>
      <div {...stylex.props(localStyles.content)}>
        <SiteFooterSitemap
          homeHref={homeHref}
          browseItems={browseItems}
          productItems={productItems}
          aboutItems={aboutItems}
          legalItems={legalItems}
          renderLink={renderLink}
          renderSignedInOnly={renderSignedInOnly}
        />
        <SiteFooterBrand
          homeHref={homeHref}
          brand={brand}
          socialItems={socialItems}
          renderLink={renderLink}
        />
      </div>
    </footer>
  );
}

const localStyles = stylex.create({
  footer: {
    width: "100%",
    boxSizing: "border-box",
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    backgroundColor: colors.foreground,
    // The footer belongs to the outer layout; the rail is mounted by a nested page.
    paddingLeft: {
      default: 0,
      "@media (min-width: 1024px)": { ":is(body:has([data-rail]) *)": 248 },
    },
  },
  content: {
    display: "flex",
    boxSizing: "border-box",
    maxWidth: 1200,
    marginInline: "auto",
    flexDirection: "column",
    alignItems: "center",
    gap: spacing.space48,
    paddingTop: 56,
    paddingBottom: 40,
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 768px)": spacing.space48,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is(body:has([data-rail]) *)": spacing.space32,
      },
    },
  },
});
